import PageLayout from "src/pages/PageLayout";
import React from "react";

const AboutUs: React.FC = () => {
  return (
    <>
      <PageLayout>
        <div className="container py-5">
          <h1 className="text-center text-primary mb-4">About</h1>

          <div className="text-justify mb-5">
            <p>
              We, at, <a href="http://localhost:3000/">ifrjindex.com</a>,
              provides ample opportunity to researchers as well as scholars,
              publishers and HEIs to help them come under one roof and share
              knowledge, collaborate and make discoveries. We provide a
              systematic search with filters for journals, publishers and
              research papers with a mission to enhance one’s research journey
              by encouraging collaboration and ensuring transparency in the
              research and publication process.{" "}
            </p>
            <p>
              The key focus is to enhance the research experience by promoting
              collaboration and upholding transparency throughout the
              publication process. Our sophisticated filters help to narrow down
              searches based on specific criteria like subject area, publication
              type, author, journal impact factor, and open access availability.
              By streamlining the research process and facilitating
              collaboration, researchers can spend less time searching for
              information and more time conducting research.
            </p>
          </div>
          <div className="container mt-5 text-justify">
            <h2 className="text-center text-primary">Mission</h2>

            <div className="mt-4">
              <p>
                👉🏾To provide a comprehensive and accessible index of scholarly
                research, facilitating discovery and collaboration within the
                academic community. This includes employing cutting-edge
                technology to improve search functionality and ensuring diverse
                perspectives are represented. Our commitment extends to
                fostering an open and inclusive research environment.
              </p>
              <p>
                👉🏾To curate and organize high quality research information,
                making it easily available to researchers globally. We strive to
                maintain data integrity and accuracy through rigorous evaluation
                processes. Furthermore, we aim to adapt to the evolving needs of
                the research community, providing innovative tools and
                resources.
              </p>
            </div>

            <h2 className="text-center text-primary mt-5">Vision</h2>

            <div className="mt-4">
              <p>
                👉🏾To become the leading global platform for research discovery,
                connecting researchers and driving advancements in knowledge. We
                envision a future where all researchers have seamless access to
                the information they need, regardless of their location or
                discipline. We also aim to be a catalyst for interdisciplinary
                collaboration and knowledge sharing.
              </p>
              <p>
                👉🏾To be the definitive index that empowers researchers to
                accelerate scientific and academic progress. This will be
                achieved by continuously improving our platform's capabilities
                and expanding our coverage of scholarly works. We also aspire to
                be a trusted resource that promotes ethical research practices
                and supports the dissemination of impactful findings.
              </p>
            </div>
          </div>
        </div>
      </PageLayout>
    </>
  );
};

export default AboutUs;
